import axios from "axios";
import WriteToLog from "./WriteToLog";
import getObservationPatientData from "./getObservationPatientData";
import getObservationEncounterData from "./getObservationEncounterData";
import savePlanFromTempData from "./savePlanFromTempData";
let { AgeFromDateString } = require('age-calculator');

/**
 * Build patient object with patient details and encounter details
 * @param {*} accessTokenResponse 
 * @returns 
 */
async function getPicuPatientFHIR(accessTokenResponse) {
  try {
    var patient = {};
    patient.error = "";
    patient.need_patient_banner = accessTokenResponse.need_patient_banner;
    patient.patFHIRID = accessTokenResponse.patient;
    if (accessTokenResponse.encounter !== undefined) {
      patient.encFHIRID = accessTokenResponse.encounter;
    } else {
      patient.encFHIRID = "";
    }
    patient.USER_ID = accessTokenResponse.user;
    patient.planDateId = accessTokenResponse.planDateId;
    patient.planId = accessTokenResponse.planId;
    patient.timeoutId = accessTokenResponse.timeoutId;
    patient.debriefId = accessTokenResponse.debriefId;
    patient.tempPlanId = accessTokenResponse.tempPlanId;
    patient.riskModel = accessTokenResponse.riskModel;
    let access_token = accessTokenResponse.access_token;
    patient.access_token = access_token;

    let token_endpoint = accessTokenResponse.state;
    let fhir_server = token_endpoint.substr(0, token_endpoint.indexOf('oauth2'));
    const ehrconfig = await axios.get('ehrconfig.json');
    patient.fhir_server = fhir_server;

    let patientReadUrl = fhir_server + ehrconfig.data["EHR_PATIENT_READ_R4"] + patient.patFHIRID;
    //WriteToLog("PatientRead URL: " + patientReadUrl);

    // Get Patient Details from Patient.Read (R4) FHIR API
    await axios.get(
      patientReadUrl,
      { headers: {
              'Authorization': 'Bearer ' + access_token,
              'Accept': 'application/json'
              }
      })
    .then((patresponse) => {
        patresponse = patresponse.data;
        //WriteToLog("getPicuPatientFHIR Patient.Read (R4) FHIR patresponse: " + JSON.stringify(patresponse));

        if (patresponse) {
          if (patresponse.gender === 'female') {
            patient.gender = "F";
          } else if (patresponse.gender === 'male') {
            patient.gender = "M";
          } else {
            patient.gender = patresponse.gender;
          }
          patient.DOB = patresponse.birthDate;
          //patient.DOB = "2022-12-30";  // YYYY-MM-DD format

          // Calculate Age 
          let age = new AgeFromDateString(patient.DOB).age;
          let displayAge = "";
          var dob = new Date(patient.DOB);
          var now = new Date();
          var diff = Math.floor(now.getTime() - dob.getTime());
          var day = 1000 * 60 * 60 * 24;
          var days = Math.floor(diff/day);
          var age_exact_months = (days/365.25)*12;
          if (age < 1) {
            if (days < 7) {
              displayAge = days + " day";
            } else if (days >=7 && days < 84) {
              displayAge = Math.round(days/7) + " week";
            } else if (days >= 84) {
              displayAge = Math.floor(days/31) + " month";
            }
          } else {
            displayAge = age + " year";
          }
          patient.AGE = age;
          patient.DISPLAY_AGE = displayAge;
          patient.AGE_IN_EXACT_MONTHS = age_exact_months;
          patient.AGE_IN_DAYS = days;

          var identifiers = patresponse.identifier;
          for (var i=0; i < identifiers.length; i++) {
            if (identifiers[i].type !== undefined) {
              if (identifiers[i].type.text === 'EPI') {
                patient.MRN = identifiers[i].value;
                WriteToLog("MRN: " + patient.MRN);
              }
              if (identifiers[i].type.text === 'EXTERNAL') {
                patient.PATIENT_ID = identifiers[i].value;
                //WriteToLog("PATIENT_ID: " + patient.PATIENT_ID);
              }
            }
          }

          var nameArray = patresponse.name;
          for (var n=0; n < nameArray.length; n++) {
            if (nameArray[n].use !== undefined) {
              if (nameArray[n].use === 'official') {  // TODO: official name OK or use usual?
                patient.PATIENT_NAME = nameArray[n].text;
                //WriteToLog("Patient Name: " + patient.PATIENT_NAME);
              }
            }
          } 

        }
      },
      (error) => {
        var status = error;
        patient.error = "Patient.Read";
        WriteToLog("Patient.Read (R4) FHIR error: " + JSON.stringify(status));
        return error;
      }
    );

    if (patient.encFHIRID !== "") { // admitted
      // Get Encounter Details from Encounter.Read (R4) 
      let encounterReadUrl = fhir_server + ehrconfig.data["EHR_ENCOUNTER_READ_R4"] + patient.encFHIRID;
      //WriteToLog("EncounterRead URL: " + encounterReadUrl);

      await axios.get(
        encounterReadUrl,
        { headers: {
                'Authorization': 'Bearer ' + access_token,
                'Accept': 'application/json'
                }
        })
      .then((encresponse) => {
          encresponse = encresponse.data;
          //WriteToLog("getPicuPatientFHIR Encounter.Read (R4) FHIR encresponse: " + JSON.stringify(encresponse));
  
          if (encresponse) {
            if(encresponse.subject !== undefined) {
              patient.DISPLAY_NAME = encresponse.subject.display; 
              //WriteToLog("DISPLAY_NAME: " + patient.DISPLAY_NAME);
            } 
            // Get Patient Admission Details if admitted
            if (encresponse.class !== undefined && encresponse.class.display === "Admission") {
              // Get AdmitDate
              if(encresponse.period !== undefined) {
                patient.AdmitDate = encresponse.period.start;
                //WriteToLog("AdmitDate: " + patient.AdmitDate);         
              }
              // Get CSN
              var identifiers = encresponse.identifier;
              for (var k=0; k < identifiers.length; k++) {
                // CSN match to check if oid ends with 698084.8
                var result = identifiers[k].system.split(".").slice(-2).join(".");
                if (result === '698084.8') {
                  if (identifiers[k].value) {
                    patient.CSN = identifiers[k].value;
                  } else {
                    patient.CSN = '99999';        
                  }
                  WriteToLog("CSN: " + patient.CSN);
                } 
              }
              // Get UNIT, ROOM, BED
              var locationArray = encresponse.location;
              if (locationArray !== undefined){
                for (var l=0; l < locationArray.length; l++) {
                  if (locationArray[l].period !== undefined) {
                    patient.NURSING_UNIT = locationArray[l].location.display;
                  }
      
                  if (locationArray[l].physicalType !== undefined) {
                    if(locationArray[l].physicalType.text === "Room") {
                      patient.ROOM = locationArray[l].location.display;
                    }
                    if(locationArray[l].physicalType.text === "Bed") {
                      patient.BED = locationArray[l].location.display;
                    }
                  }
                } 
              }
  
            } else { // non-admitted patient but with encounter. This workflow is not expected.
              patient.AdmitDate = "";
              patient.CSN = '99999'; 
              patient.NURSING_UNIT = "";
              patient.ROOM = "";
              patient.BED = "";
            }
          }
        },
        (error) => {
          var status = error;
          patient.error = "Encounter.Read";
          WriteToLog("getPicuPatientFHIR Encounter.Read (R4) FHIR error: " + status);
        }
      );

      // Get Patient PlanDate from EHR planDateId 
      await getObservationEncounterData(patient.patFHIRID, patient.encFHIRID, patient.planDateId, patient.fhir_server, patient.access_token)
      .then(planDateResponse => {
        //WriteToLog("getPicuPatientFHIR.getObservationEncounterData PlanDate response: " + planDateResponse); 
        if (planDateResponse && planDateResponse !== "") {
          var completedPlanDate = planDateResponse;
          patient.PLAN_COMPLETE_TIMESTAMP = completedPlanDate; 
          patient.PLAN_STATUS = "Plan Complete";    
        } else { // planDateId is empty, then get Plan data from tempPlanId
          WriteToLog("Plan is empty");
          getObservationPatientData(patient.patFHIRID, patient.tempPlanId, patient.fhir_server, patient.access_token)
          .then(response => { 
            //WriteToLog("getPicuPatientFHIR.getObservationPatientData tempPlan response: " + JSON.stringify(response)); 
            if (response && response !== "") { // Just Admitted
              var json = JSON.parse(response);
              var createDT = new Date(json.CREATE_DATETIME);
              var createdate = (createDT.getMonth()+1) + "/" + createDT.getDate()  + "/" + createDT.getFullYear();
              patient.PLAN_COMPLETE_TIMESTAMP = createdate; 
              patient.PLAN_STATUS = "Plan Complete";

              // Save tempPlanId EHR value to planId EHR and Save createdate to planDateId Encounter Data
              // Clear tempPlanId EHR value and Clear planDateId Patient EHR
              var ehrValue = response;
              savePlanFromTempData(patient.PATIENT_ID, patient.CSN, patient.planId, ehrValue, patient.USER_ID, patient.planDateId, createdate, patient.fhir_server, patient.access_token, patient.tempPlanId)
              .then(saveResponse => {
                WriteToLog("getPicuPatientFHIR.savePlanFromTempData save response: " + JSON.stringify(saveResponse)); 
              })
              .catch(error => {
                WriteToLog('getPicuPatientFHIR.savePlanFromTempData trying to save just admitted patient plan error: ', error);
                patient.error = "Encounter.Read";
              });
            } else { // If tempPlan Empty
              WriteToLog("tempPlan is also empty");
              patient.PLAN_COMPLETE_TIMESTAMP = ""; 
              patient.PLAN_STATUS = "Not Complete"; 
            }
          })
          .catch(e => {
            WriteToLog('getPicuPatientFHIR.getObservationEncounterData tempPlan error: ', e);
            patient.error = "getObservationEncounterData";
          });   
        }
      })
      .catch(e => {
        WriteToLog('getObservationEncounterData PlanDate error: ', e);
        patient.error = "getObservationEncounterData";
        //navigate('/error', { state: { selectedPatient : patient, failure: "getting Patient PlanDate Data value from Epic" } });
      });
    } else { // non-admitted patient
      patient.AdmitDate = "";
      patient.CSN = '99999'; 
      patient.NURSING_UNIT = "";
      patient.ROOM = "";
      patient.BED = "";
      patient.DISPLAY_NAME = patient.PATIENT_NAME;

      // Get Patient PlanDate from EHR planDateId 
      await getObservationPatientData(patient.patFHIRID, patient.planDateId, patient.fhir_server, patient.access_token)
      .then(planDateResponse => {
        //WriteToLog("After getObservationPatientData PlanDate response: " + planDateResponse); 
        if (planDateResponse && planDateResponse !== "") {
          var completedPlanDate = planDateResponse;
          patient.PLAN_COMPLETE_TIMESTAMP = completedPlanDate; 
          patient.PLAN_STATUS = "Plan Complete";    
        } else {
          patient.PLAN_COMPLETE_TIMESTAMP = ""; 
          patient.PLAN_STATUS = "Not Complete";    
        }
      })
      .catch(e => {
        WriteToLog('getObservationPatientData PlanDate error: ', e);
        patient.error = "getObservationEncounterData";
      });
    }

    return patient;
  } catch (err) {
    WriteToLog("getPicuPatientFHIR catch error: " + err);
    patient.error = "getPicuPatientFHIR";
    // Handle the error
    if (err.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      WriteToLog('Response error:', err.response.data);
      WriteToLog('Response status:', err.response.status);
      WriteToLog('Response headers:', err.response.headers);
    } else if (err.request) {
      // The request was made but no response was received
      WriteToLog('No response received:', err.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      WriteToLog('Error:', err.message);
    }
    return null;
  }
}

export default getPicuPatientFHIR;
